import React from 'react';
import ChangePassword from '../components/ChangePassword';
import { useAuth } from '../contexts/AuthContext';

const ChangePasswordPage: React.FC = () => {
  const auth = useAuth();

  return (
    <>
      <h2>Password</h2>
      {auth.userInfo && !auth.userInfo.isSSO && <ChangePassword />}
      {auth.userInfo && auth.userInfo.isSSO && (
        <p>
          This account in linked to a Google account, so you can&apos;t change
          your password here.
        </p>
      )}
    </>
  );
};

export default ChangePasswordPage;
